import { CloudArrowUp } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { AttributeStatus } from 'companySettings/enums';
import { usePartFinderProductTypeActions } from 'companySettings/hooks';
import { IPartFinderProductType } from 'companySettings/types';
import { Button } from 'core/components';
import { NotificationPosition } from 'core/enums';
import { useAgGridClientTableContext } from 'core/states';
import { Color, Variant } from 'theme/enums';

// Publishes the drafts of the selected product types; the ones already published have nothing
// to publish.
export const PublishPartFinderProductTypesButton = () => {
  const { t } = useTranslation();

  const { selectedRows } = useAgGridClientTableContext();
  const { publishPartFinderProductTypes } = usePartFinderProductTypeActions(
    NotificationPosition.TOP
  );

  const unpublishedIds = ((selectedRows ?? []) as IPartFinderProductType[])
    .filter((row) => AttributeStatus.PUBLISHED !== row.status)
    .map((row) => row.id);

  return (
    <Button
      text={t('buttonLabelPublish')}
      variant={Variant.SOFT}
      color={Color.PRIMARY}
      startDecorator={<CloudArrowUp />}
      disabled={!unpublishedIds.length}
      onClick={() => publishPartFinderProductTypes(unpublishedIds)}
    />
  );
};
